import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

import PageLoading from '_components/PageLoading'

const Overview = React.lazy(() =>
  import('_pages/Ranktracker/Overview' /* webpackChunkName: "rt-overview" */)
)
const Competitors = React.lazy(() =>
  import('_pages/Ranktracker/Competitors' /* webpackChunkName: "rt-competitors" */)
)
const Pages = React.lazy(() =>
  import('_pages/Ranktracker/Pages' /* webpackChunkName: "rt-pages" */)
)
const Grossing = React.lazy(() =>
  import('_pages/Ranktracker/Grossing' /* webpackChunkName: "rt-grossing" */)
)
const Metrics = React.lazy(() =>
  import('_pages/Ranktracker/Metrics' /* webpackChunkName: "rt-metrics" */)
)
const Discovery = React.lazy(() =>
  import('_pages/Ranktracker/Discovery' /* webpackChunkName: "rt-discovery" */)
)
const Savings = React.lazy(() =>
  import('_pages/Ranktracker/Savings' /* webpackChunkName: "rt-savings" */)
)
const Movements = React.lazy(() =>
  import('_pages/Ranktracker/Movements' /* webpackChunkName: "rt-movements" */)
)
const Grid = React.lazy(() =>
  import('_pages/Ranktracker/Grid' /* webpackChunkName: "rt-grid" */)
)
const KeywordDetails = React.lazy(() =>
  import('_pages/Ranktracker/KeywordDetails' /* webpackChunkName: "rt-keyworddetails" */)
)
const WebsiteAuditReport = React.lazy(() =>
  import('_pages/WebsiteAudit/Report' /* webpackChunkName: "wa-rep" */)
)
const CrawledPage = React.lazy(() =>
  import('_pages/WebsiteAudit/Crawled' /* webpackChunkName: "wa-crawl" */)
)
const CompareCrawls = React.lazy(() =>
  import('_pages/WebsiteAudit/Compare' /* webpackChunkName: "wa-comp" */)
)

const SharedRoutes = () => (
  <Suspense fallback={<PageLoading />}>
    <Switch>
      <Route
        exact
        path="/share/:id"
        render={props => {
          document.title = 'Shared Overview - Ranktracker'
          return <Overview {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/competitors"
        render={props => {
          document.title = 'Shared Competitors - Ranktracker'
          return <Competitors {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/pages"
        render={props => {
          document.title = 'Shared Pages - Ranktracker'
          return <Pages {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/metrics"
        render={props => {
          document.title = 'Shared Metrics - Ranktracker'
          return <Metrics {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/grossing"
        render={props => {
          document.title = 'Shared Grossing - Ranktracker'
          return <Grossing {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/discovery"
        render={props => {
          document.title = 'Shared Discover Keywords - Ranktracker'
          return <Discovery {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/savings"
        render={props => {
          document.title = 'Shared SEO / PPC Savings - Ranktracker'
          return <Savings {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/movements"
        render={props => {
          document.title = 'Shared Keywords Movements - Ranktracker'
          return <Movements {...props} />
        }}
      />
      <Route
        exact
        path="/share/:id/grid"
        render={props => {
          document.title = 'Shared Grid - Ranktracker'
          return <Grid {...props} />
        }}
      />
      <Route
          exact
          path="/share/:id/details/:keywordId"
          render={props => {
            document.title = 'Keyword Details - Ranktracker'
            return <KeywordDetails {...props} />
          }}
        />
      <Route
        exact
        path="/share/:domainId/website-audit"
        render={props => {
          document.title = 'Audit Report - Ranktracker'
          return <WebsiteAuditReport {...props} />
        }}
      />
      <Route
        exact
        path="/share/:domainId/website-audit/pages"
        render={props => {
          document.title = 'Crawled Pages - Ranktracker'
          return <CrawledPage {...props} />
        }}
      />
      <Route
        exact
        path="/share/:domainId/website-audit/compare"
        render={props => {
          document.title = 'Compare Crawls - Ranktracker'
          return <CompareCrawls {...props} />
        }}
      />
    </Switch>
  </Suspense>
)

export default SharedRoutes
